import { constants } from '..';

export default function getRelationshipLabel(relation: string): string {
  switch (relation) {
    case constants.RELATIONSHIP_PRIMARY:
      return constants.RELATIONSHIP_LABEL_PRIMARY;
    case constants.RELATIONSHIP_SPOUSE:
      return constants.RELATIONSHIP_LABEL_SPOUSE;
    case constants.RELATIONSHIP_DEPENDENT:
      return constants.RELATIONSHIP_LABEL_DEPENDENT;
    case constants.RELATIONSHIP_DEPENDENT_ADULT:
      return constants.RELATIONSHIP_LABEL_DEPENDENT_ADULT;
    case constants.RELATIONSHIP_DEPENDENT_STUDENT:
      return constants.RELATIONSHIP_LABEL_DEPENDENT_STUDENT;
    default:
      return relation;
  }
}
